import useFetch from "./useFetch";
import { useStateValue } from "../context-store/AppStateProvider";

const useCourses = () => {
  const [{ userId }] = useStateValue();
  const [{ userSisId }] = useStateValue();
  const endpointPath = `courses/user/${userId}/${userSisId}`;
  return useFetch(endpointPath);
};

export default useCourses;
